<template>
  <div v-if="hideBar" class="nav-iconfont iconfont" @click="goBack">
    &#xe60b;
  </div>
</template>

<script>
import {
  PAGE_HOME,
  PAGE_REGISTRATION_ENDS,
  PAGE_REVIEW,
} from "@/utils/constant";
export default {
  name: "poprun_layout_nav_bar",
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
  computed: {
    hideBar() {
      const currentPath = this.$route.path.split("/")[2];
      return ![PAGE_HOME, PAGE_REGISTRATION_ENDS, PAGE_REVIEW].includes(
        currentPath
      );
    },
  },
};
</script>

<style lang="scss">
.nav-iconfont {
  color: #fff;
  cursor: pointer;
  position: fixed;
  top: 8.267vw;
  left: 5.333vw;
  z-index: 2;
  font-size: 6.4vw;
  font-weight: bold;
}
</style>
